import React from "react";
import { useGetUserRole } from "../../hooks/useGetUserRole";

const SelectionActionBar = ({
  count,
  total,
  label = "items",

  actions, // pass React nodes here (buttons, modals, etc.)
}) => {
  const { viewer } = useGetUserRole();

  if (count === 0 || viewer) return null;

  return (
    <div
      className={`overflow-hidden transition-all duration-300 ${
        count > 0 ? "max-h-20 opacity-100" : "max-h-0 opacity-0"
      }`}
    >
      <div className="flex items-center justify-between bg-neutral-100 border rounded-lg px-3 xl:px-4 py-3 mb-2">
        {/* Left side: info + select all */}
        <div className="flex items-center gap-4">
            <span className="text-sm font-medium text-neutral-700">
              {count} {count === 1 ? label.slice(0, -1) : label} selected
            </span>
        </div>

        {/* Right side: actions */}
        <div className="flex items-center gap-4">{actions}</div>
      </div>
    </div>
  );
};

export default SelectionActionBar;
